import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appToUpperCase]',
    standalone: false
})
export class ToUpperCaseDirective {
  lastValue: string;

  constructor(public ref: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event) {
    const resEventValue = event.target.value.toUpperCase();
    // Avoid max call
    if (
      !this.lastValue ||
      (this.lastValue &&
        event.target.value.length > 0 &&
        this.lastValue !== resEventValue)
    ) {
      let position = this.ref.nativeElement.selectionStart;
      this.lastValue = this.ref.nativeElement.value = resEventValue;
      this.ref.nativeElement.setSelectionRange(position, position, 'none');
      // Propagation
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('input', false, true);
      event.target.dispatchEvent(evt);
    }
  }
}
